import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../../../services/auth.service';
import { BaseService } from '../../../../../services/base.service';
import { IntegrationService } from '../../../../../services/integration.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../../services/notifications.service';
import { WebSocketService } from '../../../../../services/gateway.service';
import { DialogService } from '../../../../../services/dialog.service';
import { ModalService } from '../../../../../services/modal.service';
import { ChannelService } from '../../../../../services/channel.service';
import { NAME_PROJECT } from '../../../../../enum/constants';
import { Subject } from 'rxjs';
import { CrmService } from '../../../../../services/crm.service';

interface IFormRia {
  api_key: FormControl;
  user_id: FormControl;
}

@Component({
  selector: 'app-integration-ria',
  templateUrl: './integration-ria.component.html',
  styleUrls: ['./integration-ria.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationRiaComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  protected readonly webhookUrl = `${environment.baseURL}/webhooks/ria`;
  constructor(
    public readonly authService: AuthService,
    public readonly baseService: BaseService,
    public readonly integrationService: IntegrationService,
    public readonly channelService: ChannelService,
    private readonly notificationService: NotificationService,
    private readonly webSocketService: WebSocketService,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly modalService: ModalService,
    public readonly crmService: CrmService,
  ) {}

  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  protected readonly NAME_PROJECT = NAME_PROJECT;
  protected readonly environment = environment;

  channel_id!: string;
  account!: any;
  integration!: any;
  status!: string;

  error!: string;

  form!: FormGroup<IFormRia>;
  channels: any[] = [];
  channel: any;

  public isLoader: boolean = false;

  public statuses: any = {
    ACTIVE: { title: 'active_status', color: 'green', translate: true },
    EXPIRED: { title: 'expired_status', color: 'orange', translate: true },
    CLOSED: { title: 'closed_status', color: 'gray', translate: true },
    PAUSE: { title: 'pause_status', color: 'orange', translate: true },
  };

  ngOnInit() {
    this.channel = this.payload.channel;
    this.onInitForm();
  }

  ngOnDestroy(): void {}

  onInitForm() {
    this.form = new FormGroup({
      api_key: new FormControl(this.channel.x_data?.api_key || null, Validators.required),
      user_id: new FormControl(this.channel.x_data?.user_id || null, Validators.required),
    });
  }

  save() {
    if (this.form.dirty && this.form.valid) {
      const riaConfig = this.form.getRawValue();

      this.channelService.update(this.channel.id, { x_data: riaConfig }).subscribe((res) => {
        this.cancel('success');
      });
    } else {
      this.cancel();
    }
  }

  cancel(event?: string) {
    this.close.emit(event);
  }
}
